import moment from 'moment'
import React, { useRef, useState } from 'react'
import { checkTranslation, getObject, translate } from '../../utils/useful'
import tableComponents from '../tableComponents'


class TableRow extends React.Component {


  // componentDidUpdate(){

  // }
  // const row = useRef(null)


  // const indicatorMouseDown = (e) => {
  //     // pauseEvent(e)
  //     // if (e.stopPropagation) e.stopPropagation();
  //     // if (e.preventDefault) e.preventDefault();

  //     isDown = true
  //     document.addEventListener('mouseup', mouseUp)
  //     setTimeout(() => {
  //         cloneRow()
  //     }, 300);

  // }


  // const mouseUp = () => {
  //     isDown = false
  //     document.removeEventListener('mouseup', mouseUp)
  // }


  checkFilter(filter, source) {
    // console.log(filter)
    let result = null
    let currentOperator = "or"
    if (filter && Array.isArray(filter))
      if (filter.length == 1) {
        let operationResult = this.checkFilterCondition(filter[0], source)
        result = this.doOperation(result, currentOperator, operationResult)
      } else {
        filter.forEach(filterItem => {
          if (Array.isArray(filterItem)) {
            let operationResult = this.checkFilter([filterItem], source)
            // console.log("HERE")
            // console.log(this.checkFilter([filterItem],source))
            result = this.doOperation(result, currentOperator, operationResult)
          } else {
            currentOperator = filterItem
          }
        });
      }


    return result
  }

  doOperation(result, operation, operationResult) {
    // console.log(result)
    // console.log(operationResult)
    if (result == null) {
      return operationResult
    } else {
      switch (operation) {
        case ("or"):
          return result || operationResult
        case ('and'):
          return result && operationResult
      }
    }
  }

  checkFilterCondition(item, source) {

    let first = this.makeConditionValue(item[0], source)
    let condition = item[1]
    let second = this.makeConditionValue(item[2])

    switch (condition) {
      case ("=="):
        return first == second
      case ('>'):
        return first > second
      case ('<'):
        return first < second
      case ('<='):
        return first <= second
      case ('>='):
        return first >= second
    }
  }

  makeConditionValue(value, source) {
    let result = value
    if (typeof value == 'object' && !Array.isArray(value)) {
      if (value.key) {
        result = this.getObjectValue(value.key, source)
      }
      if (value.action && value.action == "date") {
        result = moment(new Date()).tz('Asia/Singapore').add(value.offset ? value.offset : 0, value.range ? value.range : 'days').valueOf()
        // console.log(result)
      }
    }
    // console.log(result)
    return result
  }



  getObjectValue(key, source) {
    if (source) {
      if (key.includes('.')) {
        return this.getObjectValue(key.split('.')[1], source[key.split('.')[0]])
      } else {
        return source[key]
      }
    } else {
      return null
    }
  }



  translateStatus = (stage) => {
    let translatedStage
    switch (stage) {
      case 'pending':
        translatedStage = '{{lang}}Pending'
        break;

      case 'approve':
        translatedStage = '{{lang}}Approve'
        break;

      case 'reject':
        translatedStage = '{{lang}}Reject'
        break;

      case 'needEdit':
        translatedStage = '{{lang}}Need Edit'
        break;

      case 'consultation':
        translatedStage = '{{lang}}Consultation'
        break;

      case 'done':
        translatedStage = '{{lang}}Published'
        break;
      case 'deprecate':
        translatedStage = '{{lang}}Deprecate'
        break;

      default:
        translatedStage = stage
        break;
    }
    return translatedStage
  }

  translateStage = (stage) => {
    let translatedStage
    switch (stage) {
      case 'create':
        translatedStage = '{{lang}}Create'
        break;

      case 'edit':
        translatedStage = '{{lang}}Edit'
        break;

      case 'remove':
        translatedStage = '{{lang}}Remove'
        break;

      default:
        translatedStage = stage
        break;
    }
    return translatedStage
  }

  hexToRgb = (hex) => {
    if (!hex) return '255, 255, 255'
    // Remove # if present
    hex = hex.replace('#', '')
    // Handle 3-digit hex
    if (hex.length === 3) {
      hex = hex.split('').map(char => char + char).join('')
    }
    const r = parseInt(hex.substring(0, 2), 16)
    const g = parseInt(hex.substring(2, 4), 16)
    const b = parseInt(hex.substring(4, 6), 16)
    return `${r}, ${g}, ${b}`
  }

  componentDidMount() {
    this.updateStickyStyles()
  }

  componentDidUpdate() {
    this.updateStickyStyles()
  }

  updateStickyStyles = () => {
    if (this.actionsCell) {
      const isRTL = document.body.classList.contains('rtl')
      const indicatorColor = this.props.page?.indicators && this.checkFilter(this.props.page?.indicators?.filter, this.props.data) ? (this.props.page?.indicators?.color) : null
      const bgColor = indicatorColor ? `rgba(${this.hexToRgb(indicatorColor)}, 0.1)` : 'rgba(255, 255, 255, 0.05)'
      const gradientBg = indicatorColor 
        ? `linear-gradient(135deg, rgba(${this.hexToRgb(indicatorColor)}, 0.2) 0%, rgba(${this.hexToRgb(indicatorColor)}, 0.1) 100%)`
        : 'linear-gradient(135deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.1) 100%)'
      // Force sticky positioning with enhanced glassy effect
      this.actionsCell.style.cssText += `position: sticky !important; z-index: 8 !important; background: ${gradientBg} !important; background-color: ${bgColor} !important; overflow: visible !important; backdrop-filter: blur(20px) saturate(200%) brightness(1.1) !important; -webkit-backdrop-filter: blur(20px) saturate(200%) brightness(1.1) !important;`
      if (isRTL) {
        this.actionsCell.style.cssText += `left: 0 !important; right: auto !important;`
      } else {
        this.actionsCell.style.cssText += `right: 0 !important; left: auto !important;`
      }
    }
  }

  render() {
    // console.log(this.props.page?.indicators)
    let indicator = (this.props.page?.indicators && this.checkFilter(this.props.page?.indicators?.filter, this.props.data))
    // let borderColor = "#f9f9f9"
    // if (this.props.paymentTable && last) {

    //     if (moment(prop.dueDate).startOf('day').valueOf() != moment(last.dueDate).tz('Asia/Singapore').startOf('day').valueOf()) {
    //         borderColor = '#ccddee'
    //     }
    // }

    return (

      <div ref={el => this.row = el} className="tableRow" style={{ width: this.props.widths['*'], backgroundColor: indicator ? (this.props.page?.indicators?.color) : '#fff', display: 'flex', position: 'relative' }}>


        <div onClick={() => { this.props.openRow(this.props.data, this.props.index) }} className="flexcc" style={{ cursor: 'pointer', zIndex: 1, flex: '0 0 30px', width: '30px' }}>
          <p style={{ color: '#789', fontSize: 12 }}>{this.props.index + 1}</p>
        </div>

        {this.props.headers?.map((header, index) => {
          if (header.showMain != false) {

            let isSticky = false
            if (index === 0 && Math.abs(this.props.scrollX) > 5) {
              isSticky = true
            }
            let data = getObject(this.props.data, header.key)
            if (!data) {
              data = getObject(this.props.data, header.backupKey)
            }
            let Component = tableComponents[header.type]
            // console.log('fullvalue', this.props.data)
            // console.log('fullvalue2', data)
            // console.log('header', header)
            if (header.key == 'documentStatus') {
              data = this.translateStatus(data)
            }
            if (header.key == 'activeWorkflow') {
              data = this.translateStage(data)
          }

            return (
              <div onClick={() => { if (index == 0) { this.props.openRow(this.props.data, this.props.index) } }} className={"tableBodyItem " + (isSticky ? 'stickytableBodyItem' : '')} key={header.key} style={{ transition: 'all 0.3', flex: index == 0 ? '1 0' : '0 0', maxWidth: index == 0 ? null : this.props.widths[header.key], flexBasis: this.props.widths[header.key], width: this.props.widths[header.key], cursor: index == 0 ? 'pointer' : '' }}>
                {Component && (
                  <Component data={data} fullValues={this.props.data} header={header} />
                )}
              </div>
            )
          }
        })}


        {/* {this.props.settings?.extendedActions && this.props.actions?.map((prop, index) => {
                    let isSticky = false

                    return (
                        <div className={"tableBodyItem " + (isSticky ? 'stickytableBodyItem' : '')} key={header.key} style={{ transition: 'all 0.3', flex: index == 0 ? '1 0' : '0 0', maxWidth: index == 0 ? null : this.props.widths[header.key], flexBasis: this.props.widths[prop.key] }}>
                            <p >{checkTranslation(this.props.data[prop.key])}</p>
                        </div>
                    )
                })} */}
        
        {!this.props.settings?.extendedActions && this.props.actions && Object.values(this.props.actions).length > 0 && (() => {
          const isRTL = typeof document !== 'undefined' && document.body.classList.contains('rtl')
          const indicatorColor = this.props.page?.indicators && this.checkFilter(this.props.page?.indicators?.filter, this.props.data) ? (this.props.page?.indicators?.color) : null
          const bgColor = indicatorColor ? `rgba(${this.hexToRgb(indicatorColor)}, 0.1)` : 'rgba(255, 255, 255, 0.05)'
          return (
            <div ref={el => this.actionsCell = el} className={"tableBodyItem px-3 py-1 sticky-actions"} style={{ 
              transition: 'all 0.3', 
              flex: '0 0 auto', 
              maxWidth: this.props.widths['*actions'], 
              flexBasis: this.props.widths['*actions'], 
              minWidth: this.props.widths['*actions'],
              width: this.props.widths['*actions'],
              position: 'sticky', 
              [isRTL ? 'left' : 'right']: 0, 
              zIndex: 9, 
              background: indicatorColor 
                ? `linear-gradient(135deg, rgba(${this.hexToRgb(indicatorColor)}, 0.2) 0%, rgba(${this.hexToRgb(indicatorColor)}, 0.1) 100%)`
                : 'linear-gradient(135deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.1) 100%)',
              backgroundColor: bgColor, 
              backdropFilter: 'blur(20px) saturate(200%) brightness(1.1)',
              WebkitBackdropFilter: 'blur(20px) saturate(200%) brightness(1.1)',
              boxShadow: isRTL 
                ? '2px 0 12px rgba(0,0,0,0.15), inset 1px 0 0 rgba(255, 255, 255, 0.5)' 
                : '-2px 0 12px rgba(0,0,0,0.15), inset -1px 0 0 rgba(255, 255, 255, 0.5)',
              borderLeft: isRTL ? 'none' : '1px solid rgba(255, 255, 255, 0.3)',
              borderRight: isRTL ? '1px solid rgba(255, 255, 255, 0.3)' : 'none',
              alignSelf: 'stretch'
            }}>
              <button onClick={() => this.props.openActionsModal(this.props.data, this.props.index)} style={{ background: 'linear-gradient(135deg, #10453d 0%, #10453d 75%, #146a5d 100%)', borderRadius: 20, padding: '4px 12px', border: 'none', boxShadow: '0 2px 8px rgba(16, 69, 61, 0.2)' }}>
                <p className="text-smaller text-bold " style={{ color: '#fff', fontWeight: "500" }}>{translate('Visite')}</p>
              </button>
            </div>
          )
        })()}



      </div>


    )
  }

}

export default TableRow
